const Expense = () => import('./Expense.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Expense,
  path: '/despesas',
  meta: {
    label: 'Despesas'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'expensesList',
      meta: {
        label: 'Gerenciar Despesas',
        requiredPermission: {resource: 'expense', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'expenseCreate',
      props: true,
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'expense', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'expenseEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'expense', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/expense/routes.js